import { useEffect } from 'react';

import { identifyProductTours } from '@/lib/productTours';
import { UserModel } from '@/models/UserModel';

export const useProductTourIntegrations = (user: UserModel) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: re-identify only when the user or their home facility changes, not on every render.
  useEffect(() => {
    identifyProductTours(user);
  }, [user.id, user.facility_id]);
};
